import { RolloverOtpApi } from '~/app/features/rollover-otp/utils/consts';

export class OtpCodeNotProvidedError extends Error {
  constructor() {
    super('No OTP code provided');
    this.name = 'OtpCodeNotProvidedError';
  }
}

export class OtpCodeInvalidError extends Error {
  constructor(renew) {
    super('OTP code is invalid');
    this.name = 'OtpCodeInvalidError';
    this.renew = renew;
  }
}

export class RolloverOtpService {
  constructor(ctx) {
    this._ctx = ctx;
  }

  async verifyOtpCode(code, onSuccessHandler) {
    if (!code) {
      throw new OtpCodeNotProvidedError();
    }

    const { data } = await this._ctx.$api.dispatch(RolloverOtpApi.VERIFY_ROLLOVER_SMS, { code });

    if (data && !data.verified) {
      if (data.error) {
        throw new OtpCodeInvalidError(true);
      }

      throw new OtpCodeInvalidError(data.renew);
    }

    onSuccessHandler();

    return Promise.resolve(data);
  }

  async receiveOtpCode() {
    const { success, errors } = await this._ctx.$api.dispatch(RolloverOtpApi.SEND_ROLLOVER_SMS);

    if (errors && errors.length) {
      throw new Error(errors[0]);
    }

    return success;
  }
}
